module.exports = __webpack_public_path__ + "static/media/playstation_b&w_png.9fac15cb.png";